//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class UserEditVM {
    /** Gets or sets the unique identifier of the user. */
    identifier : string;
    /** Gets or sets the username of the user. */
    username : string;
    /** Gets or sets the password of the user. */
    password : string;
    /** Gets or sets the first name of the user. */
    name : string;
    /** Gets or sets the surname of the user. */
    surname : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.username = "" ;
                this.password = "" ;
                this.name = "" ;
                this.surname = "" ;
        }
}

export class UserListVM extends UserEditVM {
    /** Gets or sets the date and time when the user was created. */
    createdOn : string ;
    /** Gets or sets the disabled data for the user. */
    disableData : DisabledData;

    constructor() 
    {
    	        super();
		            this.createdOn = null;
                this.disableData = new DisabledData();
        }
}

export class DisabledData {
    disabledOn : string ;
    disabledBy : TextIdentifier;

    constructor() 
    {
    	            this.disabledOn = null;
                this.disabledBy = new TextIdentifier();
        }
}

export class TextIdentifier {
    text : string;
    identifier : string;

    constructor() 
    {
    	            this.text = "" ;
                this.identifier = "" ;
        }
}

export class BaseApiLoginResponse {
    identifier : string;
    username : string;
    role : string;
    token : string;
    refreshToken : string;
    refreshTokenExpiryTime : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.username = "" ;
                this.role = "" ;
                this.token = "" ;
                this.refreshToken = "" ;
                this.refreshTokenExpiryTime = null;
        }
}

export class BaseCredential {
    username : string;
    password : string;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
        }
}

export class LanguageCredential extends BaseCredential {
    preferredCulture : string;

    constructor() 
    {
    	        super();
		            this.preferredCulture = "" ;
        }
}

export class LoggedUserVM {
    /** Gets or sets the preferred culture of the user. */
    preferredCulture : string;
    /** Gets or sets the email address of the user. */
    emailAddress : string;
    /** Gets or sets the unique identifier of the user. */
    identifier : string;
    /** Gets or sets the username of the user. */
    username : string;
    /** Gets or sets the role of the user. */
    role : string;
    /** Gets or sets the authentication token of the user. */
    token : string;
    /** Gets or sets the refresh token of the user. */
    refreshToken : string;

    constructor() 
    {
    	            this.preferredCulture = "" ;
                this.emailAddress = "" ;
                this.identifier = "" ;
                this.username = "" ;
                this.role = "" ;
                this.token = "" ;
                this.refreshToken = "" ;
        }
}

export class BuildVm {
    /** Gets or sets the building ID. */
    bl_id : string;
    /** Gets or sets the geographic coordinates of the building. */
    coordinateGeographic : CoordinateGeographic;
    /** Gets or sets the work request ID counter for the building. */
    wrIdCounter : number;
    /** Gets or sets a value indicating whether the building is active. */
    active : boolean;

    constructor() 
    {
    	            this.bl_id = "" ;
                this.coordinateGeographic = new CoordinateGeographic();
                this.wrIdCounter = null ;
                this.active = false ;
        }
}

export class CoordinateGeographic {
    /** Gets or sets the latitude. */
    latitude : number;
    /** Gets or sets the longitude. */
    longitude : number;

    constructor() 
    {
    	            this.latitude = null ;
                this.longitude = null ;
        }
}

/** Specifies different types of filters for buildings. */
export enum BuildingFilterEnum {
    All = 0,
    Active = 1,
    NotActive = 2,
    None = -1,
}

export class BuildDetailsVm {
    /** Gets or sets the building ID. */
    bl_id : string;
    /** Gets or sets the site ID where the building is located. */
    site_id : string;
    /** Gets or sets the complex ID where the building is located. */
    complex_id : string;
    /** Gets or sets the name of the building. */
    name : string;
    /** Gets or sets the address of the building. */
    address : string;
    /** Gets or sets the city where the building is located. */
    city : string;
    /** Gets or sets the postal code of the building. */
    cap : string;
    /** Gets or sets the country where the building is located. */
    country : string;
    /** Gets or sets the region where the building is located. */
    region : string;

    constructor() 
    {
    	            this.bl_id = "" ;
                this.site_id = "" ;
                this.complex_id = "" ;
                this.name = "" ;
                this.address = "" ;
                this.city = "" ;
                this.cap = "" ;
                this.country = "" ;
                this.region = "" ;
        }
}

export class VehicleWithDistanceFromBuildVm {
    /** Gets or sets the serial number of the vehicle. */
    sn : string;
    /** Gets or sets the unique identifier of the driver. */
    uId : string;
    /** Gets or sets the role associated with the vehicle. */
    role : string;
    /** Gets or sets the distance from the building. */
    distance : number;
    /** Gets or sets the coordinates of the vehicle. */
    coordinate : VehicleCoordinate;

    constructor() 
    {
    	            this.sn = "" ;
                this.uId = "" ;
                this.role = "" ;
                this.distance = null ;
                this.coordinate = new VehicleCoordinate();
        }
}

export class VehicleCoordinate {
    /** Timestamp of the coordinate generation in milliseconds. */
    dd : number;
    /** Geographic coordinate. */
    coordinate : CoordinateGeographic;

    constructor() 
    {
    	            this.dd = null ;
                this.coordinate = new CoordinateGeographic();
        }
}

export class TechnicalDetailsVm {
    /** Gets or sets the unique identifier of the technical entity. */
    uId : string;
    /** Gets or sets the CF ID of the technical entity. */
    cfId : string;
    /** Gets or sets the role of the technical entity. */
    role : string;
    /** Gets or sets the name of the technical entity. */
    name : string;
    /** Gets or sets the surname of the technical entity. */
    surname : string;
    /** Gets or sets the email of the technical entity. */
    email : string;
    /** Gets or sets the phone number of the technical entity. */
    phone : string;
    /** Gets or sets the vehicle details associated with the technical entity. */
    vehicleDetails : VehicleDetailsVm;

    constructor() 
    {
    	            this.uId = "" ;
                this.cfId = "" ;
                this.role = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.phone = "" ;
                this.vehicleDetails = new VehicleDetailsVm();
        }
}

export class VehicleDetailsVm {
    /** Gets or sets the model of the vehicle. */
    veicolo : string;
    /** Gets or sets the state of the vehicle. */
    stato : string;

    constructor() 
    {
    	            this.veicolo = "" ;
                this.stato = "" ;
        }
}

export class TicketVm {
    /** Gets or sets a value indicating whether the ticket is in the HWr table. */
    inHWrTabel : boolean;
    /** Gets or sets the work request ID. */
    wrId : number;
    /** Gets or sets the status of the ticket. */
    status : string;
    /** Gets or sets the description of the ticket. */
    description : string;
    /** Gets or sets the estimated labor hours for the ticket. */
    estLaborHours : number;
    /** Gets or sets the type of canone. */
    canoneType : string;
    /** Gets or sets the priority of the ticket. */
    priority : string;
    /** Gets or sets the requestor of the ticket. */
    requestor : string;
    /** Gets or sets the equipment standard. */
    eqStd : string;
    /** Gets or sets the list of CF IDs. */
    cfIdList : string[];
    /** Gets or sets the list of technical view models. */
    technicalVmList : TechnicalVm[];
    /** Gets or sets the time assigned to the ticket. */
    timeAssigned : string ;
    /** Gets or sets the estimated hours for the ticket. */
    hours_est : number;
    /** Gets or sets the building ID. */
    bl_id : string;

    constructor() 
    {
    	            this.inHWrTabel = false ;
                this.wrId = null ;
                this.status = "" ;
                this.description = "" ;
                this.estLaborHours = null ;
                this.canoneType = "" ;
                this.priority = "" ;
                this.requestor = "" ;
                this.eqStd = "" ;
                this.cfIdList = [];
                this.technicalVmList = [];
                this.timeAssigned = null;
                this.hours_est = null ;
                this.bl_id = "" ;
        }
}

export class TechnicalVm {
    /** Gets or sets the unique identifier of the technical entity. */
    uId : string;
    /** Gets or sets the CF ID of the technical entity. */
    cfId : string;
    /** Gets or sets the role of the technical entity. */
    role : string;
    /** Gets or sets the name of the technical entity. */
    name : string;
    /** Gets or sets the surname of the technical entity. */
    surname : string;

    constructor() 
    {
    	            this.uId = "" ;
                this.cfId = "" ;
                this.role = "" ;
                this.name = "" ;
                this.surname = "" ;
        }
}

export class PaginatedResponseVmOfTicketVm {
    /** Gets or sets the total number of pages. */
    totalPages : number;
    /** Gets or sets the total number of items. */
    totalItems : number;
    /** Gets or sets the number of items per page. */
    itemsPerPage : number;
    /** Gets or sets the current page number. */
    pageNumber : number;
    /** Gets or sets the data items for the current page. */
    data : TicketVm[];

    constructor() 
    {
    	            this.totalPages = null ;
                this.totalItems = null ;
                this.itemsPerPage = null ;
                this.pageNumber = null ;
                this.data = [];
        }
}

/** Represents the type of a ticket. */
export enum CanoneType {
    ALL = 0,
    OTHERS = 1,
    CANONE = 2,
    EXTRA = 3,
}

/** Represents the status of a ticket. */
export enum TicketStatus {
    Unknown = 0,
    AA = 1,
    C = 2,
    Can = 3,
    Clo = 4,
    Com = 5,
    HL = 6,
    HP = 7,
    I = 8,
    R = 9,
    Rej = 10,
    S = 11,
}

export class TicketStatusVM {
    /** Gets or sets the status of the ticket. */
    status : TicketStatus;
    /** Gets or sets the description of the status. */
    description : string;

    constructor() 
    {
    	            this.status = null;
                this.description = "" ;
        }
}

export class VehicleVm {
    /** Gets or sets the serial number of the vehicle. */
    sn : string;
    /** Gets or sets the state of the vehicle. */
    state : string;
    /** Gets or sets the geographic coordinates of the vehicle. */
    coordinateGeographic : CoordinateGeographic;
    /** Gets or sets the driver of the vehicle. */
    driver : VehicleDriver;
    /** Gets or sets the role associated with the vehicle. */
    role : string;

    constructor() 
    {
    	            this.sn = "" ;
                this.state = "" ;
                this.coordinateGeographic = new CoordinateGeographic();
                this.driver = new VehicleDriver();
                this.role = "" ;
        }
}

export class VehicleDriver {
    /** Timestamp of the driver information in milliseconds. */
    dd : number;
    /** Unique identifier of the driver. */
    uid : string;

    constructor() 
    {
    	            this.dd = null ;
                this.uid = "" ;
        }
}

export class VehicleWithDriverVm extends VehicleVm {
    /** Gets or sets the complete name of the driver. */
    completeName : string;

    constructor() 
    {
    	        super();
		            this.completeName = "" ;
        }
}

export class LocalizedValue {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = {};
        }
}

export class LocalizedEntity extends LocalizedValue {
    key : string;
    identifier : string;

    constructor() 
    {
    	        super();
		            this.key = "" ;
                this.identifier = "" ;
        }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor() 
    {
    	            this.key = "" ;
                this.value = "" ;
        }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}